import React from "react";
import { useNavigate } from "react-router-dom";

export default function Nav() {
    const navigate = useNavigate();

    const scrollToSection = (id, path) => {
        // Change the browser URL without reloading the page
        navigate(path);

        // Wait for the URL/navigation update, then scroll
        setTimeout(() => {
            const section = document.getElementById(id);

            if (section) {
                const headerOffset = 80;

                const elementPosition =
                    section.getBoundingClientRect().top;

                const offsetPosition =
                    elementPosition +
                    window.pageYOffset -
                    headerOffset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: "smooth",
                });
            }
        }, 50);
    };

    const goHome = () => {
        navigate("/");

        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <nav className="fixed top-0 left-0 right-0 z-50 flex items-center justify-between border-b border-border bg-background/80 px-6 py-4 backdrop-blur-md">

            {/* Logo */}
            <div
                className="flex items-baseline gap-2 cursor-pointer"
                onClick={goHome}
            >
                <span className="text-xl font-bold uppercase tracking-tighter">
                    Velox
                </span>

                <span className="font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
                    Titanium Dioxide
                </span>
            </div>

            {/* Navigation */}
            <div className="hidden gap-8 font-mono text-[11px] uppercase tracking-widest text-muted-foreground md:flex">

                {/* Facility */}
                <button
                    type="button"
                    className="transition-colors hover:text-foreground"
                    onClick={() =>
                        scrollToSection("facility", "/facility")
                    }
                >
                    Facility
                </button>

                {/* Process */}
                <button
                    type="button"
                    className="transition-colors hover:text-foreground"
                    onClick={() =>
                        scrollToSection("process", "/process")
                    }
                >
                    Process
                </button>

                {/* Products */}
                <button
                    type="button"
                    className="transition-colors hover:text-foreground"
                    onClick={() =>
                        scrollToSection("products", "/products")
                    }
                >
                    Products
                </button>

                {/* Contact */}
                <button
                    type="button"
                    className="transition-colors hover:text-foreground"
                    onClick={() =>
                        scrollToSection("contact", "/contact")
                    }
                >
                    Contact
                </button>

            </div>
        </nav>
    );
}